import React from "react";

export default function Dictionary() {
  return (
    <div className="text-center mt-3">
      Coded by{" "}
      <b>
        <em>
          <a
            href="https://github.com/OlhaKrasnokutska/dictionary-project"
            target="_blank"
            rel="noreferrer"
          >
            Olha Krasnokutska
          </a>
        </em>
      </b>
    </div>
  );
}
